import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component } from 'react';
import { Linking, View, TouchableOpacity, Image } from 'react-native';
import { PnmacAppBar, PnmacMediaQuery, PnmacText } from 'pnmac-universal-components';
import * as Actions from '../redux/actions/actions.js';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
var BootstrapButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '6px 12px',
    lineHeight: 1.5
  }
}, {
  index: 1
})(Button);
var ExternalLink = /** @class */function (_super) {
  __extends(ExternalLink, _super);
  function ExternalLink() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.openLink = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var link;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              link = this.props.link;
              return [4 /*yield*/, Linking.canOpenURL(link)];
            case 1:
              if (_a.sent()) {
                Linking.openURL(link);
              }
              return [2 /*return*/];
          }
        });
      });
    };
    return _this;
  }
  ExternalLink.prototype.render = function () {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      accessibilityRole: 'link',
      onPress: this.openLink
    }, children);
  };
  return ExternalLink;
}(Component);
var ForceUpdate = function (layout) {
  var theme = layout.theme;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#003087"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontWeight: "bold",
      color: "#FFF"
    }
  }, "A new version of this app exists. Please download the new version.")), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      color: "#FFF"
    }
  }, "Are you an Android user? Please click below.")), /*#__PURE__*/React.createElement(ExternalLink, {
    link: 'https:itunes.apple.com/us/app/pennymac-mobile/id1349950272?mt=8'
  }, /*#__PURE__*/React.createElement(Image, {
    style: {
      width: 150,
      height: 44
    },
    source: require("../assets/app-store.png")
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      color: "#FFF"
    }
  }, "Apple iOS users please click below.")), /*#__PURE__*/React.createElement(ExternalLink, {
    link: 'https:play.google.com/store/apps/details?id=com.pennymac.app&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
  }, /*#__PURE__*/React.createElement(Image, {
    style: {
      width: 150,
      height: 44
    },
    source: require("../assets/google-play.png")
  })))));
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(ForceUpdate);